<script lang="ts">var _a, _b, _c, _d, _e, _f, _g;
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { Readable } from 'svelte/store';
import { resolveUrl } from '../../../../../js/url';
import ActionButton from '../ActionButton/ActionButton.svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: title = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.title) || "";
$: titleColor = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.titleColor) || "var(--sso22-learnmore-title-color, #fff)";
$: backgroundColor = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.backgroundColor) || 'transparent';
$: fontSize = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.fontSize) || '24px';
$: fontFamily = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.fontFamily;
$: linkHref = (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.linkHref;
$: endWorkflow = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.endWorkflow;
const navigate = () => {
    if (endWorkflow) {
        signonManager.fireWorkflowEndEvent();
        return;
    }
    if (linkHref) {
        resolveUrl(linkHref).func();
        return;
    }
};
</script>

<CardBase {element}>
  <ActionButton onClick={navigate} title={title} fontColor={titleColor} backgroundColor={backgroundColor} fontFamily={fontFamily} borderRadius="38px" textTransform="none" />
</CardBase>

<style></style>